import React from "react";
import { paymentTypes } from "../../../../../utils/constants";
import { Col, FormGroup, Input, Label, Row, InputGroup } from "reactstrap";
import { LabelWithToolTip } from "../../../../atoms/LabelWithToolTip";
import Select from "react-select";
import LockFieldsButton from "../../../../molecules/LockFieldsButton";

const AccountNoRegNoForm = (props) => {
  return (
    <FormGroup
      style={{
        display:
          props.checkbox === paymentTypes.REGNOACCOUNT ? "block" : "none",
      }}
    >
      {/* Purpose */}
      <FormGroup>
        <LabelWithToolTip
          id="labelPurpose"
          labelText="Purpose *"
          tooltipText="How this account will be used: Payroll = salary payments; Expenditure = expenses and reimbursements; All = both payroll and expenditure."
        />
        <Select
          value={props.purpose ? props.purposeOption.find((item) => item.value === props.purpose) : null}
          onChange={(e) => props.setPurpose(e?.value)}
          options={props.purposeOption}
          placeholder="Select..."
        />
      </FormGroup>

      <FormGroup>
        <LabelWithToolTip
          id="labelRegistrationNumber"
          labelText="Registration Number *"
          tooltipText="Bank's registration number (sort code) that identifies the bank branch. Must be exactly 4 characters. Only alphanumeric characters allowed."
        />
        <Row>
          <Col sm="12">
            <input
              type="text"
              value={props.regNo}
              className="form-control"
              {...props.register("regNo")}
              onChange={props.handleOnChangeRegistrationNo}
              maxLength="4"
            />
          </Col>
        </Row>
      </FormGroup>

      <FormGroup
        style={{
          display:
            props.checkbox === paymentTypes.REGNOACCOUNT ? "block" : "none",
        }}
      >
        <LabelWithToolTip
          id="labelAccountNumber"
          labelText="Account Number *"
          tooltipText="Bank account number as it appears on your bank statement. Must be exactly 10 characters. Only alphanumeric characters and spaces allowed. Hyphens (-) are not permitted."
        />
        <Row>
          <Col sm="12">
            <InputGroup>
              <input
                type="text"
                {...props.register("bankAccountNumber")}
                className="form-control"
                onChange={props.handleAccountNo}
                maxLength="10"
              />
            </InputGroup>
          </Col>
        </Row>
      </FormGroup>

      {/* Auto-filled fields - only visible if bank selected from MyHR OR after manual Regno/Account validation */}
      {(props.selectedBankFromMyHR || props.isRegnoAccountValidated) && (
        <>
          {/* Lock/Unlock Button */}
          <LockFieldsButton allowEdit={props.allowEdit} setAllowEdit={props.setAllowEdit} />

          {/* Calculated IBAN */}
          <Row>
            <Col sm="12" md="12">
              <FormGroup>
                <Label>IBAN</Label>
                <input
                  type="input"
                  {...props.register("iban")}
                  className="form-control"
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isRegnoAccountValidated)}
                />
              </FormGroup>
            </Col>
          </Row>

          {/* Bank Name */}
          <Row>
            <Col sm="12" md="12">
              <FormGroup>
                <Label>Bank</Label>
                <input
                  type="input"
                  {...props.register("bankName", { required: false })}
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isRegnoAccountValidated)}
                  className="form-control"
                />
              </FormGroup>
            </Col>
          </Row>

          {/* Address */}
          <Row>
            <Col sm="12" md="12">
              <FormGroup>
                <Label>Address</Label>
                <input
                  type="input"
                  {...props.register("bankAddress", { required: false })}
                  className="form-control"
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isRegnoAccountValidated)}
                />
              </FormGroup>
            </Col>
          </Row>

          {/* City */}
          <Row>
            <Col sm="12" md="12">
              <FormGroup>
                <Label>City</Label>
                <input
                  type="input"
                  {...props.register("bankCity", { required: false })}
                  className="form-control"
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isRegnoAccountValidated)}
                />
              </FormGroup>
            </Col>
          </Row>

          {/* Zip Code */}
          <Row>
            <Col sm="12" md="12">
              <FormGroup>
                <Label>Zip Code</Label>
                <input
                  type="input"
                  {...props.register("bankZip", { required: false })}
                  className="form-control"
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isRegnoAccountValidated)}
                />
              </FormGroup>
            </Col>
          </Row>

          {/* Country */}
          <Row>
            <Col sm="12" md="12">
              <FormGroup>
                <Label>Country</Label>
                <input
                  type="input"
                  {...props.register("bankCountry", { required: false })}
                  className="form-control"
                  disabled={!props.allowEdit && (props.selectedBankFromMyHR || props.isRegnoAccountValidated)}
                />
              </FormGroup>
            </Col>
          </Row>
        </>
      )}
    </FormGroup>
  );
};

export default AccountNoRegNoForm;
